"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _react = _interopRequireWildcard(require("react"));

var RefreshIcon = function RefreshIcon(props) {
  return _react["default"].createElement("svg", {
    className: props.className,
    onClick: props.onClick,
    width: "60px",
    height: "60px",
    viewBox: "0 0 60 60",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": "refresh-title",
    role: "img"
  }, _react["default"].createElement("title", {
    id: "refresh-title"
  }, "Refresh Icon"), _react["default"].createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, _react["default"].createElement("g", {
    transform: "translate(-74.000000, -568.000000)"
  }, _react["default"].createElement("g", {
    transform: "translate(74.000000, 568.000000)"
  }, _react["default"].createElement("path", {
    d: "M39.7379612,20.259375 C37.1081926,17.63125 33.4990619,16 29.4909318,16 C21.4746717,16 15,22.48875 15,30.5 C15,38.51125 21.4746717,45 29.4909318,45 C36.2557849,45 41.8961851,40.378125 43.5103189,34.125 L39.7379612,34.125 C38.2507817,38.348125 34.2245153,41.375 29.4909318,41.375 C23.4878049,41.375 18.6091307,36.499375 18.6091307,30.5 C18.6091307,24.500625 23.4878049,19.625 29.4909318,19.625 C32.5015635,19.625 35.1857411,20.875625 37.1444653,22.85125 L31.3045654,28.6875 L44,28.6875 L44,16 L39.7379612,20.259375 Z",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), _react["default"].createElement("circle", {
    stroke: "#FFFFFF",
    strokeWidth: "2",
    cx: "30",
    cy: "30",
    r: "29"
  })))));
};

var _default = RefreshIcon;
exports["default"] = _default;